export const enum fileColName {
  lineNum = "שורה מס'",
  userId = 'מזהה',
  firstName = 'שם פרטי',
  lastName = 'שם משפחה',
  subscriberNumber = 'טלפון',
  userType = 'מדרג',
  amountOfFunding = 'סכום מימון',
}
export const enum userType {
  regular = 'regular',
  senior = 'senior',
}

export enum InvalidCellReason {
  IsEmpty = 'ריק',
  ContainDigits = 'מכיל ספרות',
  ContainChar = 'מכיל אותיות',
  InvalidId = ' צריך להכיל 9 ספרות', //!=9
  InvalidPhone = 'צריך להכיל 10 ספרות', //!=10
  InvalidType = ' סוג לקוח  תקין',
  general = 'לא תקין',
}
